module.exports = __webpack_public_path__ + "img/studiosha_card_back.d6796154.png";